import { render, staticRenderFns } from "./RobotGlobe.vue?vue&type=template&id=47c4ed94&scoped=true"
import script from "./RobotGlobe.vue?vue&type=script&lang=js"
export * from "./RobotGlobe.vue?vue&type=script&lang=js"
import style0 from "./RobotGlobe.vue?vue&type=style&index=0&id=47c4ed94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4ed94",
  null
  
)

export default component.exports